import { FC } from 'react';
import { ChartProps, Doughnut } from 'react-chartjs-2';
import { ArcElement, Chart as ChartJS, ChartOptions, Legend, Tooltip } from 'chart.js';

import { getChartOptions } from '../helpers';

ChartJS.register(ArcElement, Tooltip, Legend);

type DoughnutChartProps = {
  title: string;
  labels: string[];
  data: number[];
  colors: string[];
  valueType: 'price' | 'percent';
};

export const DoughnutChart: FC<DoughnutChartProps> = ({
  title,
  labels,
  data,
  colors,
  valueType,
}) => {
  const options: ChartOptions<'doughnut'> = getChartOptions(valueType, 'doughnut');

  const chartData: ChartProps<'doughnut'>['data'] = {
    labels,
    datasets: [
      {
        label: title,
        data,
        backgroundColor: colors,
        hoverOffset: 4,
      },
    ],
  };

  return <Doughnut data={chartData} options={options} />;
};
